export function flatObject(obj) {
    var rtn = {};
    for (const [key, value] of Object.entries(obj)) {
        //check if the object is array type
        if (Array.isArray(value)) {
            //map the values and insert the key & value for each element
            value.map((items, i) =>
                Object.entries(items).map((item) => {
                    rtn[key + "[" + i + "]." + item[0]] = item[1];
                })
            );
        } else {
            if (key.includes("fileUploader")) {
                delete obj[key];
            } else {
                Object.entries(value).map((item) => {
                    rtn[key + "." + item[0]] = item[1];
                });
            }
        }
    }
    return rtn;
}

export function unflattenObject(flatObject) {
    const result = {};

    for (const [key, value] of Object.entries(flatObject)) {
        const keys = key.split('.');
        let current = result;

        for (let i = 0; i < keys.length; i++) {
            const currentKey = keys[i];
            const isArray = /\[\d+\]$/.test(currentKey);

            if (isArray) {
                const arrayKey = currentKey.substring(0, currentKey.indexOf('['));
                const arrayIndex = parseInt(currentKey.substring(currentKey.indexOf('[') + 1, currentKey.indexOf(']')));
                current[arrayKey] = current[arrayKey] || [];
                if (i === keys.length - 1) {
                    current[arrayKey][arrayIndex] = value;
                } else {
                    current[arrayKey][arrayIndex] = current[arrayKey][arrayIndex] || {};
                    current = current[arrayKey][arrayIndex];
                }
            } else {
                if (i === keys.length - 1) {
                    current[currentKey] = value;
                } else {
                    current[currentKey] = current[currentKey] || {};
                    current = current[currentKey];
                }
            }
        }
    }

    return result;
};

export function convertToFlatJSON(urlEncodedString) {
    const jsonObject = {};
    urlEncodedString = urlEncodedString.replace(/[{}]/g, '');
    const pairs = urlEncodedString.split('|');

    pairs.forEach(pair => {
        // Split each key-value pair
        const [key, value] = pair.split('=');
        if (key) {
            jsonObject[key] = decodeURIComponent(value || '');
        }
    });
    return jsonObject;
}

export function groupBy3(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}